import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { Equipment } from "@/types/Equipment";

interface EquipmentState {
    equipment: Equipment[];
    loading: boolean;
    error: string | null;
}

// Define the initial state:
const initialState: EquipmentState = {
    equipment: [],
    loading: false,
    error: null,
};

const equipmentSlice = createSlice({
    name: "equipment",
    initialState,
    reducers: {
        // Add a new Equipment item
        addEquipment(state, action: PayloadAction<Equipment>) {
            state.equipment.push(action.payload);
        },

        // Remove an Equipment by ID
        removeEquipment(state, action: PayloadAction<number>) {
            state.equipment = state.equipment.filter(
                (eq) => eq.id !== action.payload
            );
        },

        // Update an existing Equipment by ID
        // If not found, no changes will be made
        updateEquipmentRedux(state, action: PayloadAction<Equipment>) {
            const updatedItem = action.payload;
            const index = state.equipment.findIndex(
                (eq) => eq.id === updatedItem.id
            );
            if (index !== -1) {
                state.equipment[index] = updatedItem;
            }
        },

        setEquipment(state, action: PayloadAction<Equipment[]>) {
            state.equipment = action.payload;
        },
    },
});

export const {
    addEquipment,
    removeEquipment,
    updateEquipmentRedux,
    setEquipment,
} = equipmentSlice.actions;

export default equipmentSlice.reducer;